import {Component, Input} from '@angular/core';
import {MatSidenav} from '@angular/material';

@Component({
  selector: 'iaud-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent {
  enableNavigation: boolean = false;

  @Input() sidenav: MatSidenav;
}
